import type { Styles } from 'src/theme/themes';

const styles = {
  barLabel: {
    height: '2.5rem',
    textAlign: 'center',
    whiteSpace: 'wrap',
    fontWeight: 600,
    overflowY: 'auto',
  },
} satisfies Styles;

export default styles;
